import { Bet } from '../entities/bet';

export { Bet }

export class GameGroup {
    public GameGroupId: number;
    public Fullname: string;
    public IsDefault: boolean;
    public Bets: Bet[];
}


// WEBPACK FOOTER //
// ./src/entities/gamegroup.ts